import _ from 'lodash'

const state = {
  list: []
}

const mutations = {
  setList(state, list) {
    state.list = list || []
  }
}

const getters = {
  for_user(state, _getters, rootState) {
    const user = rootState.auth.user
    if (user.admin) {
      return state.list
    }
    return _.filter(state.list, (p) => _.includes(p.groups, user.group))
  },
  name_by_id(state) {
    return _.mapValues(_.keyBy(state.list, '_id'), 'name')
  }
}

const actions = {
  async refresh({ commit }) {
    const list = await this._vm.$api.get('/products')
    commit('setList', list)
  }
}

export default { namespaced: true, state, mutations, actions, getters }
